import PripomienkaListPage from './PripomienkaListPage';

export default PripomienkaListPage;
